<template>
  <div>
    <slot
      name="field"
      v-bind="{
        props: {
          modelValue: form.values[fieldName],
          error: form.errors[fieldName],
          errorMessages: form.errors[fieldName] ? form.errorMessages[fieldName] : '',
        },
        on: {
          'update:modelValue': ($event) => $emit('update:modelValue', { [fieldName]: $event }),
          change: () => $emit('change', { [fieldName]: true }),
        },
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'DpplFormField',
  props: {
    form: { type: Object, default: () => ({}) },
    fieldName: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'change'],
};
</script>
